import { render, staticRenderFns } from "./OrderBasicInfo.vue?vue&type=template&id=007fcc9e"
import script from "./OrderBasicInfo.vue?vue&type=script&lang=js"
export * from "./OrderBasicInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports